import assert from '@/sui/tools/assert'
import { dynamic } from '@/sui/tools/chart/formatter'
import options from '@/sui/tools/chart/options'

function classic (id, title, dataset, labels, opt = {}) {
  assert(id != null)
  assert(title != null)
  assert(dataset != null)
  assert(labels != null)

  const formatters = [
    dynamic.numbers,
    dynamic.computedPercent,
    dynamic.computedPercentWithValue
  ]

  const exportConfig = [
    options.titleFontSize(12),
    options.title,
    options.datalabelFontSize(),
    options.hideDatalabelBelowPercent,
    options.legendFontSize,
    options.legendBoxWidth,
    options.hideLegend,
    options.selectFormatter(
      formatters,
      opt.defaultFormatter == null ? 2 : opt.defaultFormatter
    ),
    options.legendOnRight,
    options.borderWidth
  ]

  return {
    type: 'doughnut',
    icon: 'doughnut',
    id: id,
    config: {
      data: {
        labels: labels,
        datasets: dataset
      },
      options: {
        title: {
          display: true,
          text: title
        },
        cutoutPercentage: 40,
        rotation: -0.7 * Math.PI,

        legend: {
          display: true,
          position: 'bottom'
        },

        elements: {
          arc: {
            borderWidth: options.borderWidth.default,
            backgroundColor: '#ffffff'
          }
        },

        plugins: {
          datalabels: {
            color: '#ffffff',
            font: {
              weight: 'bold'
            },
            textAlign: 'center',
            offset: 0,
            formatter: dynamic,
            display: function (context) {
              const index = context.dataIndex
              const value = context.dataset.data[index]
              return value > 0
            }
          }
        }
      }
    },

    exportConfig: exportConfig
  }
}

export default {
  classic
}
